import { Grid, TextField, TextFieldProps } from '@mui/material';
import type { GridSize } from '@mui/material';

type SttFormTextareaProps = {
    grid?: boolean;
    caption?: string;
    onChange?: (value: { name: string | undefined; value: unknown }) => void;
    defVal?: string | null;
    name?: string;
    rows?: number;
    placeholder?: boolean;
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
    lg?: GridSize;
    xl?: GridSize;
} & Omit<TextFieldProps, 'placeholder' | 'onChange'>;

export function SttFormTextarea({
    xs = 12,
    sm,
    md,
    lg,
    xl,
    grid = false,
    caption,
    onChange,
    defVal,
    name,
    rows,
    placeholder = false,
    ...rest
}: SttFormTextareaProps) {
    const content = (
        <TextField
            fullWidth
            multiline
            minRows={rows || 3}
            variant="outlined"
            label={!placeholder ? caption : undefined}
            size="small"
            value={defVal || ''}
            onChange={(e: any) => onChange?.({ name, value: e.target.value })}
            inputProps={placeholder ? { placeholder: caption } : {}}
            {...rest}
        />
    );

    return grid ? (
        <Grid size={{ xs, sm, md, lg, xl }}>{content}</Grid>
    ) : (
        content
    );
}
